import { render, staticRenderFns } from "./PriceFormatDropdownField.vue?vue&type=template&id=a9b2a282"
import script from "./PriceFormatDropdownField.vue?vue&type=script&lang=ts"
export * from "./PriceFormatDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9b2a282')) {
      api.createRecord('a9b2a282', component.options)
    } else {
      api.reload('a9b2a282', component.options)
    }
    module.hot.accept("./PriceFormatDropdownField.vue?vue&type=template&id=a9b2a282", function () {
      api.rerender('a9b2a282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/PriceFormatDropdownField.vue"
export default component.exports